import { Component, OnInit } from '@angular/core';
import { CardToken, CardTokenQuery } from '@fgb/core';
import * as luxon from 'luxon';
import { Observable } from 'rxjs';

@Component({
  selector: 'fgb-ecash-button',
  templateUrl: './ecash-button.component.html',
  styleUrls: ['./ecash-button.component.scss'],
})
export class EcashButtonComponent implements OnInit {
  cardToken$: Observable<CardToken | undefined>;
  nonDefaultCardTokens$: Observable<CardToken[]>;

  constructor(private cardTokenQuery: CardTokenQuery) {}

  ngOnInit(): void {
    this.cardToken$ = this.cardTokenQuery.selectDefaultCard();
  }

  isExpired(expiryDate: string) {
    if (!expiryDate) return false;
    const now = luxon.DateTime.utc();
    const expiriedDate = luxon.DateTime.fromISO(expiryDate);
    return now > expiriedDate;
  }
}
